import React from "react";

import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <section className="section bg-theme-dark-alt tc-light" id="principles">
        <div className="container">
          {/* Block @s */}
          <div className="nk-block nk-block-features-s2">
            <div className="row align-items-center flex-row-reverse">
              <div className="col-lg-5">
                <div className="gfx py-4">
                  <img
                    src="images/gfx/gfx-a.png"
                    className="animate__animated animate__fadeInUp animate__delay-1s"
                    data-animate="fadeInUp"
                    data-delay=".3"
                    alt="gfx"
                  />
                </div>
              </div>
              {/* .col */}
              <div className="col-lg-7">
                {/* Section Head @s */}
                <div
                  className="section-head animate__animated animate__fadeInUp animate__delay-1s"
                  data-animate="fadeInUp"
                  data-delay=".45"
                >
                  <h2 className="title">كيف يساعدك عون؟</h2>
                  <p></p>
                </div>
                {/* .section-head @e */}
                <div
                  className="features-list me-4 mgb-m30 animate__animated animate__fadeInUp animate__delay-1s"
                  data-animate="fadeInUp"
                  data-delay=".55"
                >
                  <div className="feature feature-s2">
                    <div className="feature-icon dot">
                      <em className="icon ikon ikon-shiled-alt" />
                    </div>
                    <div className="feature-text">
                      <h5 className="title title-sm">
                        {" "}
                        صعوبة في إنتاج تقرير شامل
                      </h5>
                      <p>
                        يمكن أن يساعدك عون من خلال تلخيص الاجتماعات وتنظيم
                        المعلومات بطريقة واضحة وموجزة. وهذا يضمن أن يتم التقاط
                        جميع التفاصيل الرئيسية بدقة ، وأن يكون التقرير شاملاً
                        وفعالاً.
                      </p>
                    </div>
                  </div>
                  <div className="feature feature-s2">
                    <div className="feature-icon dot">
                      <em className="icon ikon ikon-user" />
                    </div>
                    <div className="feature-text">
                      <h5 className="title title-sm">
                        {" "}
                        صعوبة في تحديد المهام الخاصة بي
                      </h5>
                      <p>
                        يمكن للمساعد الشخصي تعيين المهام وتتبعها ، مما يضمن أن
                        يعرف الجميع ما هو مسؤول عنه ومتى يجب إكماله. يساعد هذا
                        في تقليل الارتباك وتحسين الكفاءة ، مما يؤدي إلى سير عمل
                        أفضل.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="feature feature-s2">
                    <div className="feature-icon dot">
                      <em className="icon ikon ikon-data-server" />
                    </div>
                    <div className="feature-text">
                      <h5 className="title title-sm">
                        انخفاض كبير في الإنتاجية
                      </h5>
                      <p>
                        يمكن أن يساعد المساعد الشخصي في زيادة الإنتاجية من خلال
                        التعامل مع المهام الإدارية مثل الجدولة وإدارة البريد
                        الإلكتروني. هذا يوفر الوقت للموظفين للتركيز على عملهم ،
                        مما يؤدي إلى بيئة عمل أكثر إنتاجية وكفاءة. بالإضافة إلى
                        ذلك ، من خلال قدرتهم على تلخيص الاجتماعات ، يمكن
                        للمساعدين الشخصيين التأكد من التقاط جميع النقاط الرئيسية
                        ، مما يقلل من فرص فقدان المعلومات أو سوء الفهم.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* .col */}
            </div>
            {/* .row */}
          </div>
          {/* .block @e */}
        </div>
      </section>
    </React.Fragment>
  );
};
export default About;
